import React, { useState, useEffect, useMemo, useCallback } from 'react';

import Spin from 'antd/es/spin';

import { Title } from 'components/Text';
import { Row, Col } from 'components/layout';

import SettingsList from '../components/SettingsList';
import AlertsSettingsService from 'services/alertsSettings';

const alertsSettingsSchema = [
  {
    name: 'iddle_start',
    inputType: 'switch',
    title: 'Idle Start',
  },
  {
    name: 'iddle_end',
    inputType: 'switch',
    title: 'Idle End',
  },
  {
    name: 'process_slow',
    inputType: 'switch',
    title: 'Process Slow',
  },
  {
    name: 'process_stopped',
    inputType: 'switch',
    title: 'Process Stopped',
  },
  {
    name: 'missing_tags',
    inputType: 'switch',
    title: 'Missing Tags',
  },
];


const AlertPreferences = ({ showMessage }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [settingsValues, setSettingsValues] = useState([]);

  const alertsSettingsService = useMemo(() => {
    return new AlertsSettingsService();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    alertsSettingsService.getAlertsSettings()
      .then(data => {
        if (!data) return;

        setSettingsValues(data.map(item => {
          return {
            id: item.id,
            name: item.notification_type,
            value: item.is_active === 1,
            description: item.description,
            modified: false,
            locationId: item.location_id,
          };
        }));
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, [alertsSettingsService]);

  const onSettingsValueChanged = useCallback((settingsValue) => {
    alertsSettingsService.updateAlertsSettings({
      id: settingsValue.id,
      is_active: settingsValue.value ? 1 : 0,
    }).then(() => {
      const valueSchema = alertsSettingsSchema.find(schemaItem => schemaItem.name === settingsValue.name);
      if (valueSchema) {
        const { title } = valueSchema;
        showMessage('success', `${title} alerts ${settingsValue.value ? 'enabled' : 'disabled'}`);
      }
    }).catch(() => {
      showMessage('error', 'Failed to update alerts');
    })
  }, [showMessage, alertsSettingsService]);

  useEffect(() => {
    const modifiedValue = settingsValues.find(value => value.modified);
    if (modifiedValue) {
      onSettingsValueChanged(modifiedValue);
      setSettingsValues(values => values.map(value => {
        value.modified = false;
        return value;
      }));
    }
  }, [settingsValues, onSettingsValueChanged]);

  if (isLoading) {
    return (
      <Spin
        size={30}
        style={{ width: '100%', padding: '36px' }}
      />
    );
  }

  return (
    <Row justify="center">
      <Col span={18}>
        <Title
          level={4}
          style={{
            textAlign: 'center',
            marginBottom: '32px'
          }}
        >
          Toggle Alerts
        </Title>
        <SettingsList
          settingsSchema={alertsSettingsSchema}
          settingsValues={settingsValues}
          setSettingsValues={setSettingsValues}
        />
      </Col>
    </Row>
  );
};

export default AlertPreferences;
